import { DialogContent, DialogActions } from '../Dialog/Dialog';
import React, { useEffect, useState, useRef } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import DialogTitle from '@material-ui/core/DialogTitle';
import MicroPhoneLogo from '../../../components/MicroPhoneLogo';

const styles = makeStyles(theme => ({
    closeButton: {
        fontSize: 18,
        color: '#e0e0e0',
    },
    featureName: {
        fontSize: 20,
        fontWeight: 300
    },
    brV1: {
        borderRadius: '16px'
    },
    dcV1: {
        display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', paddingTop: 32, paddingBottom: 32,
    },
    mtV1: {
        marginTop: 56
    },
    divV1: {
        display: 'flex', justifyContent: 'space-between', alignItems: 'center'
    },
    divV2: {
        fontSize: 24, fontWeight: 500, marginTop: 9
    },
    divV3: {
        display: "flex", justifyContent: 'center', alignItems: 'center', opacity: '0.6', flexDirection: 'column', marginTop: 8
    },
    mtV2: {
        marginTop: 2
    },
    daV1: {
        paddingTop: 0, paddingLeft: 8, paddingRight: 8, paddingBottom: 8
    },
    buttonV1: {
        backgroundColor: '#0b1323', color: 'white', textTransform: 'capitalize', paddingTop: 17, paddingBottom: 17, borderRadius: '8px', fontWeight: 'bold', fontSize: 16,
        "&:hover": {
            backgroundColor: '#0b1323'
        }
    }
}));


const ComingSoonModal = ({ featureName, open, onClose }) => {

    const [onOpen, setOnOpen] = React.useState(open);

    const classes = styles();

    const handleClose = () => {
        setOnOpen(false)
        onClose();
    }

    return (
        <>
            <Dialog fullWidth={true}
                maxWidth='xs' classes={{ paperScrollPaper: classes.brV1 }}
                onClose={handleClose} disableEscapeKeyDown={true} disableBackdropClick={true} aria-labelledby="add-party-dialog-title" open={onOpen}>
                <DialogTitle id="add-party-dialog-title">
                    <div className={classes.divV1}>
                        < div className={classes.featureName} >{featureName ? featureName : 'Feature'}</div>
                        <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
                            <CloseIcon />
                        </IconButton>
                    </div>
                </DialogTitle>
                <Divider />
                <DialogContent className={classes.dcV1}>
                    <div>
                        <MicroPhoneLogo />
                    </div>
                    <div className={classes.divV2} > Coming Soon</div>
                    <div className={classes.divV3}>
                        <div>
                            Feature will be live on the web soon
                         </div>
                        <div className={classes.mtV2}>
                            We will update you once it comes
                        </div>
                    </div>
                </DialogContent>
                <DialogActions className={classes.daV1} >
                    <Button fullWidth className={classes.buttonV1} onClick={handleClose} >
                        Okay
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default ComingSoonModal;